import {
  productosEmpresa,
  productosEmprendedor
} from "@/config/constants/paso4-productos";

describe("productosEmpresa", () => {
  it("should have the correct properties", () => {
    expect(productosEmpresa).toHaveProperty("producto1");
    expect(productosEmpresa).toHaveProperty("producto2");
    expect(productosEmpresa.producto1).toHaveProperty("titulo");
    expect(productosEmpresa.producto1).toHaveProperty("descripcion");
    expect(productosEmpresa.producto2).toHaveProperty("titulo");
    expect(productosEmpresa.producto2).toHaveProperty("descripcion");
  });

  it("should have the correct values", () => {
    expect(productosEmpresa.producto1.titulo).toBe("Líneas de financiación");
    expect(productosEmpresa.producto1.descripcion).toBe(
      "Te contamos todas las lineas a las que podés acceder con condiciones especiales. Financiá tu empresa con las mejores opciones de Préstamos a Tasa Especial, Descuento de Cheques, Adelanto de Cupones VISA; Tarjetas de Crédito o Descubierto en Cuenta Corriente. Tenemos la mejor opción para tu empresa."
    );
    expect(productosEmpresa.producto2.titulo).toBe("Cobros y pagos");
    expect(productosEmpresa.producto2.descripcion).toBe(
      "Gestioná la caja de tu empresa con las mejores herramientas digitales. Asesorate para conocer cómo operar con nuestras terminales de cobro, Botón de Pago digital; Pago de haberes con beneficios para vos y tus empleados y Pago Mis Cuentas."
    );
  });
});

describe("productosEmprendedor", () => {
  it("should have the correct properties", () => {
    expect(productosEmprendedor).toHaveProperty("producto1");
    expect(productosEmprendedor).toHaveProperty("producto2");
    expect(productosEmprendedor.producto1).toHaveProperty("titulo");
    expect(productosEmprendedor.producto1).toHaveProperty("descripcion");
    expect(productosEmprendedor.producto2).toHaveProperty("titulo");
    expect(productosEmprendedor.producto2).toHaveProperty("descripcion");
  });

  it("should have the correct values", () => {
    expect(productosEmprendedor.producto1.titulo).toBe(
      "Líneas de financiación"
    );
    expect(productosEmprendedor.producto1.descripcion).toBe(
      "Obtené financiación preferencial para tu emprendimiento o comercio, solo necesitás tener certificado Mipyme vigente."
    );
    expect(productosEmprendedor.producto2.titulo).toBe(
      "Seguro integral de comercio"
    );
    expect(productosEmprendedor.producto2.descripcion).toBe(
      "Te ofrecemos un seguro adaptado a las necesidades de tu negocio y una bonificación hasta el 40% en las primeras 3 cuotas."
    );
  });
});
